// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBv4B74g18VrFjJyKAWLA4dSZ0fLec387s",
  authDomain: "salon-karte-12f9d.firebaseapp.com",
  projectId: "salon-karte-12f9d",
  storageBucket: "salon-karte-12f9d.firebasestorage.app",
  messagingSenderId: "1071159239252",
  appId: "1:1071159239252:web:8c89069f0dfe94804003c1",
};

// Firebaseの初期化
const app = initializeApp(firebaseConfig);

// 各機能を使えるようにエクスポート
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
